import React, { useEffect } from "react";
import "../../../style/block.scss";
import "../../../style/feature.scss";
import useSchedule from "./hooks/useSchedule";
import "./style.scss";
import "../../../style/block.scss";
import "../../../style/buttons.scss";

import ExerciseBar from "./exerciseBar";
import ScheduleDesktop from "./scheduleDesktop";
import ScheduleMobile from "./scheduleMobile";
import ExerciseBarMobile from "./exerciseBar/exercisebarMobile";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useSelector } from "react-redux";
import { State } from "../../store";

const ScheduleExerise: React.FC = () => {
  const saleConfiguration = useSelector((state: State) => state.config.configuration);
  const {
    today,
    nextWeek,
    previousWeek,
    dateToState,
    dateFromState,
    sortByExerciseGroup,
    resetSortByExerciseGroup,
    previousDay,
    nextDay,
    dayFromStateMobile,
    dayToStateMobile,
    getFirstAllExercises,
    exercisesList,
    loading,
    refreshExercisesList,
  } = useSchedule();

  useEffect(() => {
    getFirstAllExercises();
    //eslint-disable-next-line
  }, []);

  const matches = useMediaQuery("(min-width: 1100px)");
  return (
    <div className="container">
      <div className="headline">
        {saleConfiguration.componentList && (
          <React.Fragment>
            {saleConfiguration.componentList.map((item) => (
              <React.Fragment>{item.id === "Calendar" && <h1>{item.name}</h1>}</React.Fragment>
            ))}
          </React.Fragment>
        )}

        <div className="line"></div>

        {saleConfiguration.message_fitnessExercise && (
          <React.Fragment>
            {saleConfiguration.message_fitnessExercise.length > 12 ? (
              <div className="alert alert-comment">
                <article dangerouslySetInnerHTML={{ __html: saleConfiguration.message_fitnessExercise }}></article>
              </div>
            ) : (
              <React.Fragment></React.Fragment>
            )}
          </React.Fragment>
        )}
      </div>
      {matches ? (
        <React.Fragment>
          <ExerciseBar
            nextWeek={nextWeek}
            previousWeek={previousWeek}
            dateToState={dateToState}
            dateFromState={dateFromState}
            sortByExerciseGroup={sortByExerciseGroup}
            resetSortByExerciseGroup={resetSortByExerciseGroup}
          />
          <ScheduleDesktop
            today={today}
            dateFromState={dateFromState}
            exercisesList={exercisesList}
            loading={loading}
            onRefreshExercises={refreshExercisesList}
          />
        </React.Fragment>
      ) : (
        <React.Fragment>
          <ExerciseBarMobile
            nextWeek={nextDay}
            previousWeek={previousDay}
            dateToState={dayToStateMobile}
            dateFromState={dayFromStateMobile}
            sortByExerciseGroup={sortByExerciseGroup}
            resetSortByExerciseGroup={resetSortByExerciseGroup}
          />
          <ScheduleMobile
            dateFromState={dayFromStateMobile}
            exercisesList={exercisesList}
            loading={loading}
            onRefreshExercises={refreshExercisesList}
          />
        </React.Fragment>
      )}
    </div>
  );
};

export default ScheduleExerise;
